module.exports = __webpack_public_path__ + "static/media/homeImage@2x.14070f1e.png";